import { Location as LocationAngular, PlatformLocation } from '@angular/common';
import { Inject, Injectable, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
// import { NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { UtilsService } from '../commons/utils.service';
import { LOCATION } from '../location';
import { UserService } from './../user/user.service';
import { AuthConfigService } from './auth.config';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

export class NotSignedInError extends Error {
  constructor(message) {
    super(message);
    this.name = 'NotSignedInError';
  }
}
@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {
  constructor(
    // private oauthService: OAuthService,
    private platformLocation: PlatformLocation,
    @Inject(LOCATION) private location: Location,
    private authConfigService: AuthConfigService,
    private userService: UserService,
    private injector: Injector,
    private http: HttpClient
  ) {}

  // isLogin(): boolean {
  //     return !!this.getAccessToken();
  // return (
  //   this.oauthService.hasValidIdToken() &&
  //   this.oauthService.hasValidAccessToken()
  // );
  // }
  // async loginAuthCodeFlow() {
  //   this.setupAuthConfig();
  //   await this.oauthService.loadDiscoveryDocument();
  //   //add state if needed
  //   this.oauthService.initLoginFlow();
  // }

  // async tryLoginFirst() {
  //   this.setupAuthConfig();
  //   this.oauthService.loadDiscoveryDocumentAndTryLogin();
  // }
  // async loadDiscoveryDocumentAndLoginCodeFlow() {
  //   this.setupAuthConfig();
  //   return this.oauthService.loadDiscoveryDocumentAndLogin();
  // }
  // get idTokenClaim(): any {
  //   return this.oauthService.getIdentityClaims();
  // }
  logOut() {
    this.location.assign(
      UtilsService.normalizeResourceUri(
        this.platformLocation.getBaseHrefFromDOM() + '/assets/logout.html'
      )
    );
  }
  // private setupAuthConfig() {
  //   window.addEventListener('storage', this.storageListener.bind(this));
  //   this.oauthService.configure(this.authConfigService.authConfig);
  //   this.oauthService.setStorage(localStorage);
  //   this.oauthService.setupAutomaticSilentRefresh({}, 'access_token');
  //   this.oauthService.tokenValidationHandler = new NullValidationHandler();
  // }
  /**
   * initiate auth when the app is loaded
   * used with APP_INITIALIZER
   */
  async initAuth(): Promise<any> {

    // Temporary solution to redirect traffic from omnitracsone to omnitracs domain
    // this.validateDomain();
      // if(this.getAccessToken()){
      //   this.userService.setBusinessAccountFromAccessToken(
      //     // this.oauthService.getAccessToken(),
      //     // 'omnitracs.com/business_account'
      //     this.getAccessToken(),
      //     'co'
      //   );
      // }
   // return new Promise((resolveFn, rejectFn) => {
    //   if(this.getAccessToken()){
    //   this.userService.setBusinessAccountFromAccessToken(
    //     // this.oauthService.getAccessToken(),
    //     // 'omnitracs.com/business_account'
    //     this.getAccessToken(),
    //     'co'
    //   );
      // }
      // this.loadDiscoveryDocumentAndLoginCodeFlow().then(isLoggedIn => {
      //   if (isLoggedIn) {
      //     this.userService.setBusinessAccountFromAccessToken(
            // this.oauthService.getAccessToken(),
            // 'omnitracs.com/business_account'
          //   this.getAccessToken(),
          //   'co'
          // );
        //   if (this.oauthService.state) {
        //     const router = this.injector.get(Router);
        //     router.navigateByUrl(this.oauthService.state);
        //   }
        //   resolveFn(true);
        // } else {
        //   const location = this.injector.get(LocationAngular);
        //   this.oauthService.initCodeFlow(location.path(true));
        //   rejectFn(this.getSignedInError());
        // }
      // });
    // });
  }

  hasAdministratorPrivileges() {
    return this.userService.hasAdministratorPrivileges(
      this.getAccessToken()
    );
  }

  // refreshToken() {
  //   return this.oauthService.refreshToken();
  // }
  getAccessToken() {
    // return this.oauthService.getAccessToken();
    return localStorage.getItem('access_token');
  }

  // redirectNavigation() {
  //   const router = this.injector.get(Router);
  //   console.log('Inside redirectNavigation of AuthService');
  //   if (localStorage.getItem('dashboardPath')) {
  //     console.log(
  //       'Inside dashboardPath of AuthService',
  //       localStorage.getItem('dashboardPath')
  //     );
  //     router.navigateByUrl(localStorage.getItem('dashboardPath'));
  //   } else if (localStorage.getItem('iftaPath')) {
  //     console.log(
  //       'Inside iftaPath of AuthService',
  //       localStorage.getItem('iftaPath')
  //     );
  //     router.navigateByUrl(localStorage.getItem('iftaPath'));
  //   } else if (localStorage.getItem('reportsPath')) {
  //     console.log(
  //       'Inside reportsPath of AuthService',
  //       localStorage.getItem('reportsPath')
  //     );
  //     router.navigateByUrl(localStorage.getItem('reportsPath'));
  //   } else {
  //     console.log('Invalid path: ', router.url);
  //   }
  // }

  ngOnDestroy(): void {
    // window.removeEventListener('storage', this.storageListener.bind(this));
  }
  // private storageListener() {
  //   if (!this.oauthService.hasValidAccessToken()) {
  //     this.location.reload();
  //   }
  // }
  // private getSignedInError() {
  //   return new NotSignedInError('Not yet signed in');
  // }

  getGP2Token(): Observable<any> {
    const url = 'https://login.microsoftonline.com/SoleraFLTNADev.onmicrosoft.com/oauth2/v2.0/token';

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin':'*'
    });

    const body = new HttpParams()
      // .set('client_type','Single-Page Application')
      .set('grant_type', 'client_credentials')
      .set('client_id', '856842eb-8bb7-41e2-92cb-57419ccd2258')
      .set('scope', 'https://SoleraFLTNADev.onmicrosoft.com/ac77a01a-2894-447d-bcd1-58f7646a2f14/.default')
      .set('client_secret', '8k18Q~7H1mCb.ze.AeYwumJ~z3t17-MDh8ZGKbkg');

    return this.http.post(url, body.toString(), { headers });
  }

  getLocalStorageGP2Token() {
    return localStorage.getItem('gp2_token');
  }

  private validateDomain() {
    const esDomain = '.omnitracsone.com';
    const ot1Domain = '.omnitracs.com';
    const notifyRedirectionParam = 'notifyRedirection=true';
    const { host, href, search } = this.location;
    if (host.indexOf(esDomain) !== -1) {
      this.location.href = `${href
        .replace(esDomain, ot1Domain)
        .replace('.test.', '.int.')}${
        search ? '&' : '?'
      }${notifyRedirectionParam}`;
      throw new Error('Invalid domain');
    }
  }

  // This make re-usable in every app.component of the applications.
  prepareRedirectUrl(applicationPort: string): void {
    const token = localStorage.getItem('access_token');

    if (token) {
        return;
    }

    const [subdomain, ...domainParts] = location.host.split('.');
    const applicationUrl = window.location.origin;

    if (domainParts.length > 0) {
        const dynamicDomain = domainParts.join('.');
        const loginUrl = `${window.location.protocol}//login.${dynamicDomain}`;
        const redirectUrl = `${loginUrl}/auth?response_type=token&client_id=TAX&redirect_uri=${encodeURIComponent(applicationUrl)}&scope=authz`;

        window.location.href = redirectUrl;
    } else {
      /**
        * NOTE: To local development, update the environment of login to the desired one.
        * (DEV: dev, TEST - QAE: int)
        */
        const fallbackUrl = `https://login.dev.omnitracs.com/auth?response_type=token&client_id=TAX&redirect_uri=https://localhost:${applicationPort}/&scope=authz`;
        window.location.href = fallbackUrl;
    }
  }

}
